<template>
    <div class="my-4">
        <b-list-group>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
                {{website}}
                <b-icon icon="link" scale="2" variant="primary"></b-icon>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
                {{phone}}
                <b-icon icon="telephone" scale="2" variant="primary"></b-icon>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center" style="white-space: pre-line">
                {{address}}
                <b-icon icon="map" scale="2" variant="primary"></b-icon>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<style scoped>

</style>

<script>
export default {
    data() {
        return {

        }
    },
    computed: {
        place: {
            get() {
                return this.$store.state.place_current_data
            }
        },
        website: {
            get() {
                var website = ''
                if (Object.keys(this.place).length !== 0) {
                    website = this.place.name.toLowerCase().trim() + '.com'
                }
                return website
            }
        },
        phone: {
            get() {
                var phone = ''
                if (this.place != null) {
                    phone = this.place.phone
                }
                return phone
            }
        },
        address: {
            get() {
                var addrStr = ''
                if (this.place.locationAddress1 != '') {
                    addrStr = addrStr + this.place.locationAddress1 + ', '
                }
                if (this.place.locationAddress2 != '') {
                    addrStr = addrStr + this.place.locationAddress2 + ', \n'
                }
                if (this.place.locationAddress3 != '') {
                    addrStr = addrStr + this.place.locationAddress3 + ', '
                }
                if (this.place.locationCity != '') {
                    addrStr = addrStr + '\n' + this.place.locationCity + ', '
                }
                if (this.place.locationZip != '') {
                    addrStr = addrStr + this.place.locationZip + ', '
                }
                addrStr = addrStr + 'Philippines'

                return addrStr
            }
        }
    }
}
</script>